module.exports = __webpack_public_path__ + "imgesssyaa/svg/Exchange.58a93c34.svg";